import React from 'react'

export const Send = ({ fill, className }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" className={className} width="15px" height="15px" viewBox="0 0 19.178 19.178" fill={fill ? fill : '#bdbdbd'}>
            <path id="Path_2021" data-name="Path 2021" d="M18.8.072a.685.685,0,0,0-.614,0h0L.379,8.976a.685.685,0,0,0,.184,1.286L7.63,11.548l1.286,7.068a.685.685,0,0,0,.576.555.668.668,0,0,0,.1.007A.685.685,0,0,0,10.2,18.8L19.106.991A.685.685,0,0,0,18.8.072Z" transform="translate(-0.001 0)" />
        </svg>
    )
}
